export default {
  form: {
    display_name: {
      label: 'Nom du restaurant',
      placeholder: 'Entrez le nom du restaurant',
      help: 'Utilisé sur votre contrat et vos factures',
    },
    store_address: {
      label: 'Adresse du magasin',
      placeholder: 'Rechercher votre adresse',
      help: "Il s'agit de l'adresse visible par vos clients",
    },
    address: {
      label: 'Adresse',
      placeholder: 'Rue + numéro',
    },
    zip_code: {
      label: 'Code postal',
      placeholder: 'Code postal',
    },
    city: {
      label: 'Ville',
      placeholder: 'Ville',
    },
    state: {
      label: 'État',
      placeholder: "Sélectionner l'état",
    },
    country: {
      label: 'Pays',
      help: 'Pour déplacer votre restaurant vers un autre pays, contactez le support',
    },
  },
  staff_notice:
    "Le personnel du restaurant ne peut pas confirmer le nom et l'adresse de l'établissement. Veuillez demander à votre gestionnaire d'intégration de vérifier ces informations.",
  toasts: {
    saved: 'Détails du magasin enregistrés',
    error: "Impossible d'enregistrer les détails du magasin",
  },
  buttons: {
    next: 'Suivant',
  },
};
